import { useObjectContext } from '@/hooks/useObjectContext';
import { Stack, Typography, useTheme } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import React from 'react';
import { useSelector } from 'react-redux';
import { FolioDrawerHeader } from '@/components/Drawers/FolioDrawer/FolioDrawerHeader';

const DialogHeader = () => {
	const theme = useTheme();

	const dialogData = useSelector((state) => state.dialog?.data?.askAi) ?? {};

	const { clientRow, dealRow } = useObjectContext();

	const resolvedClient = dialogData.client ?? clientRow ?? null;
	const resolvedDeal = dialogData.deal ?? dealRow ?? null;

	const contextType = dialogData.contextType ?? (resolvedDeal ? 'deal' : 'client');
	const isClientContext = contextType === 'client';

	const scopeLabel = isClientContext ? 'Client context' : 'Deal context';
	const contextTitle = isClientContext ? resolvedClient?.name : resolvedDeal?.dealName;

	return (
		<>
			<FolioDrawerHeader
				title='Folio AI'
				icon={<AutoAwesomeIcon sx={{ color: theme.palette.folioPurple }} />}
				isBeta
			/>
			<Stack direction='row' spacing={1} alignItems={'center'} sx={{ px: 2, flexShrink: 0 }}>
				<Typography sx={{ fontSize: '0.98rem', fontWeight: 600, color: theme.palette.text.primary }}>
					{contextTitle ?? scopeLabel}
				</Typography>
				{scopeLabel !== contextTitle && (
					<Typography sx={{ fontSize: '12px', color: theme.palette.text.secondary }}>
						({scopeLabel})
					</Typography>
				)}
			</Stack>
		</>
	);
};

export default DialogHeader;
